import MainLayout from 'layouts/MainLayout';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ApiOverviewHeader from './ApiOverviewHeader';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import {
    fetchCollectionsList,
} from 'redux-store/collectionActions';
import { useDispatch } from 'react-redux';
import ApiEndpointTable from './ApiEndpointTable';
import { getMethodBadgeStyle } from 'config/constants';

const ApiOverview = ({ project, collectionId = null }) => {
    const dispatch = useDispatch();
    const [collectionData, setCollectionData] = useState(null);
    const [apiEndpointsCount, setApiEndpointsCount] = useState([]);
    const [collections, setCollections] = useState([]);
    const [selectedCollectionId, setSelectedCollectionId] = useState(null);

    const fetchAllCollections = async () => {
        try {
            const res = await dispatch(fetchCollectionsList({ projectId: project?.id })).unwrap();
            if (res && res.length > 0) {
                setCollections(res);
                const targetCollection = collectionId
                    ? res.find(c => c.id === collectionId) || res[0]
                    : res[0];
                setSelectedCollectionId(targetCollection.id);
                setCollectionData(targetCollection);
            } else {
                setCollections([]);
                setSelectedCollectionId(null);
                setCollectionData(null);
            }
        } catch (error) {
            console.error('Error fetching collections:', error);
            setCollections([]);
            setSelectedCollectionId(null);
            setCollectionData(null);
        }
    };

    useEffect(() => {
        if (project?.id) {
            fetchAllCollections();
        }
    }, [project?.id]);

    const handleCollectionChange = async (event) => {
        const newCollectionId = event.target.value;
        if (newCollectionId === selectedCollectionId) return;
        setSelectedCollectionId(newCollectionId);
        try {
            const selectedCollectionData = collections.find(c => c.id === newCollectionId);
            if (selectedCollectionData) {
                setCollectionData(selectedCollectionData);
            }
        } catch (error) {
            console.error('Error fetching collection data:', error);
        }
    };

    return (
        <MainLayout
            headerText={`API Overview`}
            subtitleText={`Collection: ${collectionData?.name || 'N/A'}`}
        >
            <div className="h-screen overflow-y-auto p-6 bg-[var(--background-secondary)]" style={{ marginLeft: "-24px", marginRight: "-24px", marginTop: "-32px" }}>
                <div className="mb-4">
                    <FormControl sx={{ minWidth: 300 }}>
                        <InputLabel id="collection-select-label">Select Collection</InputLabel>
                        <Select
                            labelId="collection-select-label"
                            value={selectedCollectionId || ''}
                            label="Select Collection"
                            onChange={handleCollectionChange}
                            size="small"
                            disabled={collections.length === 0}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            sx={{
                                backgroundColor: 'var(--background-primary)',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'var(--borderColor)',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'var(--primary-color)',
                                },
                            }}
                        >
                            {collections.length === 0 && <MenuItem value="" disabled>No collections available</MenuItem>}
                            {collections.map((collection) => (
                                <MenuItem key={collection.id} value={collection.id}>
                                    {collection.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className='shadow-sm rounded-lg border !border-[var(--borderColor)]'>
                    <ApiEndpointTable
                        getMethodBadgeStyle={getMethodBadgeStyle}
                        collectionId={selectedCollectionId}
                        setApiEndpointsCount={setApiEndpointsCount}
                    />
                </div>
            </div>
        </MainLayout>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        project: state.common.selectedProject ?? ownProps.project,
    };
};

export default connect(mapStateToProps)(ApiOverview);
